export const interpolateLocaleString = (text: string, values?: { [key: string]: any }) => {
  if (!text) return "";
  if (values) {
    Object.keys(values).forEach((key) => {
      text = text.replace(`{{${key}}}`, values![key]?.toString())
    });
  }
  return text;
}